/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TherapistProfile } from './therapistProfile';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PaginatedTherapistProfileList { 
    next?: string | null;
    previous?: string | null;
    results: Array<TherapistProfile>;
}
export const PaginatedTherapistProfileList_next_Validators: ValidatorFn[] =
    [ ];

export const PaginatedTherapistProfileList_previous_Validators: ValidatorFn[] =
    [ ];

export const PaginatedTherapistProfileList_results_Validators: ValidatorFn[] =
    [  Validators.required, ];


